import { money } from "./format";

export const DISPLAY_CURRENCIES = ["TRY", "USD", "AED", "EUR"];

export const toDisplay = (tlValue, currency, rates) => {
  if (currency === "TRY") return tlValue;
  const rate = rates?.[currency];
  return rate ? tlValue / rate : 0;
};

export const fmtDisplay = (tlValue, currency = "TRY", rates = {}) =>
  money(toDisplay(tlValue, currency, rates), currency);
